export default __webpack_public_path__ + "static/media/Nairagram.b2b85c12.png";